@if (selectedZone) {
    <div class="center-xy" [style.overflow]="overflow ? 'auto' : 'hidden'">
        <div class="zone-control-wrapper bg-light" data-testid="valve-control">
            <div class="zone-control__top">
                <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                    <img [ngSrc]="iconSrc" width="45" height="45" alt="" />
                </div>
                <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                    {{ zoneName }}
                </p>
            </div>

            <div class="zone-control__content">
                <div class="zone-control__buttons-top">
                    <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                         data-testid="close-control" (click)="goHome()">
                        <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                             width="40" height="40" alt="" />
                    </div>
                </div>
                <div class="zone-control__current-temp font-76">
                    <p>{{ selectedZone.tile.params.currentTemp | format:7 }}</p>
                </div>
                <div class="zone-control__set-temp font-45 bg-settings bg-settings--zone font-bold color-alarm">
                    <p class="zone-control__set-temp-value">
                        {{ selectedZone.tile.params.setTemp | format:7 }}
                    </p>
                </div>
                <div class="zone-control__mode-select zone-control__mode-select--valve font-bold">
                    <div class="zone-control__select">
                        <div class="zone-control__select-icon" (click)="goToMenu()">
                            <icon [iconName]="'menu-fitters'" [iconSize]="80"
                                  [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                            </icon>
                            <icon [iconName]="'menu-fitters'" [iconSize]="80"
                                  [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                            </icon>
                        </div>
                        <p>{{ labels.menu }}</p>
                    </div>
                    <div class="zone-control__select zone-control__select--settings">
                        <div class="zone-control__select-icon" (click)="goToInfo()">
                            <icon [iconName]="'settings'" [iconSize]="80"
                                  [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                            </icon>
                            <icon [iconName]="'settings'" [iconSize]="80"
                                  [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                            </icon>
                        </div>
                        <p>{{ labels.settings }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
